'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _iview = require('iview');

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

var _play = require('@/mixins/play');

var _play2 = _interopRequireDefault(_play);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import store from '@/store'
exports.default = {
  mixins: [_play2.default],
  data: function data() {
    return {
      fixStyle: {
        'bottom': 0
      },
      showInfo: false,
      courseID: '',
      courseName: '',
      isBottom: true,
      linksList: [],
      concatList: [],
      otherLink: [],
      otherValue: 'all',
      dataList: []
    };
  },
  created: function created() {
    window.onscroll = null;
    // this.getOtherList()
    // this.getLinksList()
    // this.findDictList()
    // setTimeout(() => {
    //   let isShowHead = !store.state.hideRouterName.includes(this.$route.name)
    //   if (isShowHead) {
    //     this.getOtherList()
    //     this.getLinksList()
    //     this.findDictList()
    //   }
    // }, 100)
  },

  methods: {
    // 各区学习网
    getOtherList: function getOtherList() {
      var _this = this;

      // let menus = [
      //   { label: '各区学习网', value: 'all' },
      //   { label: '西城区', value: 'http://www.westcityedu.com/index.html' },
      //   { label: '海淀区', value: 'http://online.zgcxy.bjedu.cn/web/index.aspx' },
      //   { label: '顺义区', value: 'http://www.shyxue.com/index.shtml' },
      //   { label: '密云区', value: 'http://www.myqmxx.cn/#/Start' }
      // ]
      var menus = [{ label: '各区学习网', value: 'all' }];
      this.$ajax({
        url: 'api-classes/portal/open/subplatform/listSubPlatform',
        method: 'GET',
        data: {}
      }).then(function (_ref) {
        var data = _ref.data;

        _this.dataList = data.data;
        data.data.forEach(function (item) {
          menus.push({
            label: item.platformName,
            value: item.platformUrl
          });
        });
      });
      this.otherLink = menus;
    },

    // 跳转
    jumpPage: function jumpPage(item) {
      if (item == 1 || item == 2) {
        var _url = item == 1 ? 'http://beian.miit.gov.cn/' : 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038172';
        window.open(_url, '_blank');
        return;
      }
      window.open(item.informationUrl, '_blank');
    },

    // 获取友情链接
    getLinksList: function getLinksList() {
      var _this2 = this;

      this.linksList.length = 0;
      this.$ajax({
        url: 'api-information/portal/open/information/getSpecificCategoryV2',
        method: 'GET',
        data: {
          searchCategoryCode: 'sqxy'
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.linksList = data.data.slice(0, 4);
      });
    },

    // 获取数据字典
    findDictList: function findDictList() {
      var _this3 = this;

      this.concatList.length = 0;
      this.$ajax({
        url: 'api-basic/portal/open/dicttype/findDictList?typeCodes=INDEX_BOTTOM_CONTACT',
        method: 'GET'
      }).then(function (_ref3) {
        var data = _ref3.data;

        var list = data.data[0].dicts;
        _this3.concatList = list.slice(0, 6);
      });
    },
    getPosition: function getPosition(footerDom) {
      var scrollY = window.pageYOffset || (document.documentElement || document.body).scrollTop;
      if (scrollY >= this.total) {
        this.isBottom = false;
        return;
      }
      this.isBottom = true;
    },
    initBottomScroll: function initBottomScroll() {
      var scrollY = window.pageYOffset || (document.documentElement || document.body).scrollTop;
      var height = (document.documentElement || document.body).offsetHeight;
      var footerTop = this.$refs.Footer.getBoundingClientRect().top;
      this.total = scrollY + footerTop - height;
      this.getPosition();
    },
    initScroll: function initScroll() {
      var _this4 = this;

      var footerDom = document.querySelector('.iv-footer');
      this.initBottomScroll();
      this.$on('hook:beforeDestroy', function () {
        window.onscroll = null;
        window.onresize = null;
      });
      window.onscroll = function () {
        _this4.getPosition(footerDom);
      };
      window.onresize = function () {
        _this4.initBottomScroll();
        _this4.getPosition(footerDom);
      };
    },

    // 联系我们
    jumpAbout: function jumpAbout() {
      if (this.$route.name == 'concatDetail') return;
      var routeUrl = this.$router.resolve({
        name: 'concatDetail'
      });
      window.open(routeUrl.href, '_blank');
    }
  },
  components: {
    Poptip: _iview.Poptip,
    IconFont: _iconfont2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//